import { useEffect } from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'
import * as Sentry from '@sentry/react'
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://7783c48d3f5141b283dc4bcaa5e92563@o4504832929103872.ingest.us.sentry.io/4504832930676736',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
    beforeSend(event, hint) {
      if (
        hint?.originalException instanceof Error &&
        hint.originalException.message.includes('Objects are not valid as a React child')
      ) {
        return null // Filter it out
      }
      return event
    },
  })
}
